import React from 'react';

const Chat = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.56711 3.06111C5.73267 1.525 8.82767 1.65056 10.8299 3.35889C12.8671 5.09611 13.1454 7.93556 11.4699 9.96834C9.891 11.8833 7.04489 12.5144 4.67489 11.5267L4.546 11.4706L2.11545 11.9878L2.07378 11.995L2.01267 12L1.94989 11.9978L1.92545 11.995L1.86434 11.9839L1.806 11.965L1.75045 11.9406L1.70822 11.9172L1.64822 11.8744L1.60322 11.8333L1.56267 11.7872L1.53322 11.7456L1.49711 11.6817L1.47378 11.6228L1.45656 11.56L1.44934 11.5183L1.44434 11.4572L1.44656 11.3944L1.44934 11.37L1.46045 11.3089L1.47267 11.2689L2.11156 9.35167L2.09934 9.33167C0.871558 7.25 1.42767 4.66945 3.43878 3.155L3.56656 3.06167L3.56711 3.06111Z",
      fill: "white",
      stroke: "white",
      strokeWidth: "0.833333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
Chat.displayName = "Icons.Chat";

export { Chat };
//# sourceMappingURL=Chat.js.map
